import { PATH_URL } from './path-url';

const BASE = `${PATH_URL}/beneficios/off-v2`;

/** URL de la imagen de descuento por value. Las keys coinciden con el `value` de discount-value. */
export const DISCOUNT_IMAGES: Record<string, string> = {
  '5': `${BASE}/05.png`,
  '10': `${BASE}/10.png`,
  '15': `${BASE}/15.png`,
  '25': `${BASE}/25.png`,
  '35': `${BASE}/35.png`,
  '50': `${BASE}/50.png`,
  '70': `${BASE}/70.png`,
  '85': `${BASE}/85.png`
};
